class KitSelector {
  constructor(element) {
    this.section = element;
    this.form = this.section.querySelector('[data-kit-form]');
    
    if (!this.form) {
      console.error('Kit form not found');
      return;
    }

    document.addEventListener("theme:partner:set", (event) => {
      this.partner = event.detail.partner;
    });

    this.kitButton = this.section.querySelector('[data-business-kit-add]');
    if (!this.kitButton) {
      console.error('Kit button not found');
      return;
    }

    this.checkCart();
    
    this.kitButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.checkCartAndInitialize();
    });
    
    // Get and log customer data
    this.initCustomerData();

    // Check if customer is a consultant and disable buttons if true
    if (this.isConsultant()) {
      this.disableKitButton();
    }
  }

  disableKitButton() {  
    this.kitButton.disabled = true;
    this.kitButton.classList.add('disabled');
    this.kitButton.textContent = window.theme.strings.enrollmentNotAllowed;
  }

  initCustomerData() {
    try {
      const customerDataElement = this.section.getAttribute('data-customer');
      if (customerDataElement && customerDataElement !== 'null') {
        // Decode HTML entities and parse JSON
        const decodedData = customerDataElement
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&amp;/g, '&');
        
        const customer = JSON.parse(decodedData);
        this.customer = customer;
      } else {
        console.log('Customer not logged in');
        this.customer = null;
      }
    } catch (error) {
      console.error('Error parsing customer data:', error);
      console.log('Raw customer data:', this.section.getAttribute('data-customer'));
      this.customer = null;  
    }
  }

  async checkCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const kitVariantId = this.form.querySelector('[name="id"]').value;
      console.log(kitVariantId,'kitVariantId');
      const kitInCart = cart.items.find(item => 
        item.variant_id.toString() === kitVariantId
      );

      if (kitInCart) {
        this.disableKitButton();
      }
    } catch (error) {
      console.error('Error checking cart:', error);
    }
  }
  updateHeaderTotal() { 
        return fetch(`${window.theme.routes.cart}.js`).then((response)=>{
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
              detail: {
                  cart: response.data
              },
              bubbles: true
          }));
      }).catch((e)=>{
          console.error(e);
      });
    }

  async checkCartAndInitialize() {
    this.checkCart().then(async () => {
     
        // Disable button and show loading state
        const kitButtonLabel = this.kitButton.textContent;
        this.kitButton.disabled = true;
        this.kitButton.textContent = 'Adding to cart...';

        // Ahead of the add, so the Packaging & Fulfillment fee line sorts BELOW the kit rather
        // than above it — checkout orders line items by the cart, and the most recently added
        // line lands at the top. Defined in theme.js; optional-called in case this script runs
        // on a page that did not load it. Everything it awaits is inside a 3s deadline — the
        // clamped cart-API cooldown included, which is why that sleep is abortable — so it
        // cannot leave this button stuck on "Adding to cart..." waiting on a stalled cart API.
        await window.seedPackagingFeeLine?.();

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              id: this.kitButton.dataset.variantId,
              quantity: 1
          })
        })
        
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .catch(error => {
          // Scoped to the ADD, deliberately, and placed before the success handler rather
          // than after it. Chained at the end it also caught throws from the success path and
          // reset the button as though the add had failed, on a cart where it had not.
          console.error(error);
          // Put the button back. Without this a failed add leaves it disabled reading
          // "Adding to cart..." forever, with no way out but a reload.
          this.kitButton.disabled = false;
          this.kitButton.textContent = kitButtonLabel;
          // The fee was seeded BEFORE this add, so a failure here can leave it behind — and on
          // a cart with nothing else that is a payable $4.95 checkout for nothing, since the
          // fee variant does not require shipping and the row has no remove control. Cannot
          // just clear the cart the way Build-a-Box does: this path never cleared it, so the
          // shopper may have their own items in there. Hand it to reconcileFulfillmentFee
          // instead, which is the component that owns the decision — it drops the fee when no
          // shippable merchandise remains and leaves it alone when some does.
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
          throw error;
        })
        .then(data => {
          this.kitButton.textContent = window.theme.strings.enrollmentNotAllowed;
          this.updateHeaderTotal();
          setTimeout(() => {
            const cartDrawer = document.querySelector('.cart__drawer');
            if (cartDrawer) {
              cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
            } else {
              console.error('Cart drawer element not found');
            }
          }, 600);
        })
        .catch(() => {
          // Already handled and logged by the add's own catch above, which rethrows so this
          // one still settles the chain. Nothing further to do.
        });
       
    });
  }    

  isConsultant() {
    try {
      if (this.customer && this.customer.tags) {
        // Convert tags to array if it's a string
        const tags = Array.isArray(this.customer.tags) 
          ? this.customer.tags 
          : this.customer.tags.split(',').map(tag => tag.trim());
        
        return tags.includes('UserType_Consultant');
      }
      return false;
    } catch (error) {
      console.error('Error checking consultant status:', error);
      return false;
    }
  }
}

// Initialize on both DOMContentLoaded and section load
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-kit-selector]');
  if (section) {
    new KitSelector(section);
  }
});

